import React from 'react';
import MrHeatPump from './MrHeatPump_Base.png';
import MrHeatPumpPOC from './MrHeatPumpPOC_Base.png';
import MrsHeatPump from './MrsHeatPump_Base.png';
import MrsHeatPumpPOC from './MrsHeatPumpPOC_Base.png';

/**
 * MrHP - Heat Pump Mascot Component
 * 
 * Renders a mascot character SVG image for educational purposes.
 * Supports multiple character variants based on gender and person of color representation.
 * 
 * @component
 * @param {Object} props - Component properties
 * @param {number} props.x - X coordinate position in SVG space
 * @param {number} props.y - Y coordinate position in SVG space
 * @param {number} props.width - Width of the mascot image in pixels
 * @param {number} props.height - Height of the mascot image in pixels
 * @param {boolean} [props.lady=false] - If true, renders female character variant
 * @param {boolean} [props.poc=false] - If true, renders person of color variant
 * 
 * @returns {JSX.Element} SVG image element with the selected mascot character
 * 
 * @example
 * // Default male character
 * <MrHP x={0} y={0} width={135} height={200} />
 * 
 * @example
 * // Female character
 * <MrHP x={50} y={100} width={135} height={200} lady={true} />
 * 
 * @example
 * // Male person of color character
 * <MrHP x={0} y={0} width={135} height={200} poc={true} />
 */
export function MrHP({ x, y, width, height, lady = false, poc = false }) {
  // Determine which character image to display based on props
  let characterImage = null;

  if (lady && poc) {
    // Female person of color variant
    characterImage = MrsHeatPumpPOC;
  } else if (lady) {
    // Female variant
    characterImage = MrsHeatPump;
  } else if (poc) {
    // Male person of color variant
    characterImage = MrHeatPumpPOC;
  } else {
    // Default male variant
    characterImage = MrHeatPump;
  }

  return (
    <image
      x={y}
      y={x}
      href={characterImage}
      width={width}
      height={height}
      alt={`Heat pump mascot character - ${lady ? 'Mrs' : 'Mr'} HP${poc ? ' POC' : ''}`}
    />
  );
}

export default MrHP;